export default "__VITE_ASSET__GwZi4FUDdk2Ax0TQ6Lw9Bg__"